/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LanguageResource
 */
export interface LanguageResource {
    /**
     * 
     * @type {string}
     * @memberof LanguageResource
     */
    code?: string;
}

/**
 * Check if a given object implements the LanguageResource interface.
 */
export function instanceOfLanguageResource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LanguageResourceFromJSON(json: any): LanguageResource {
    return LanguageResourceFromJSONTyped(json, false);
}

export function LanguageResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageResource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function LanguageResourceToJSON(value?: LanguageResource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

